<template>
<div class="col-10 box-border" >
    <div class="row d-flex details align-items-center mt-0 justify-content-between">
        <div v-if="!info.name" class="col-7 d-flex align-items-center">
            <el-skeleton style="width: 70%; height: 60px;" animated>
                <template slot="template">
                    <el-skeleton-item variant="rect" style="width: 70%; height: 60px;" />
                </template>
            </el-skeleton>
        </div>
        <div v-else class="col-7 d-flex align-items-center">
            <div class="col-3 box-border mt-0 p-2 d-flex align-items-center justify-content-center" v-if="info.logo">
                <img
                    crossorigin="anonymous"
                    :src="`${urlApi}/${info.logo}`"
                    alt=""
                    class="buyer-img"
                >
            </div>
            <div class="break-col" :class="(!info.logo) ? 'col-12 px-0' :  'col-9' ">
                <div>
                    <NameInitials :name="info.name" v-if="!info.logo" />
                </div>
                <div>
                    <caption class="bold c-nmidone mb-0">grupo econômico</caption>
                    <h4 class="bold c-ndarkfour break d-block mb-0">
                        {{info.name | formatName}}
                    </h4>
                </div>
            </div>
        </div>
        <div v-if="info.id" class="col-3 text-right">
            <Button size="small" type="outline" :color="getPrimaryColor" class="mb-3" @click="dialogVisible=true" v-if="info.aboutPhoto">
                Sobre o sacado
            </Button>
        </div>
    <div class="col-12 my-4">
        <hr>
    </div>
    </div>
    <div class="row">
        <div class="col-4 pr-0 reduce-container">
            <h5 class="medium c-darkfour">Dados gerais</h5>
            <div class="infos mt-4">
                <caption class="c-nmidone bold">Local</caption>
                <BoxLoadingText v-if="!info.id" />
                <h5 class="bold c-ndarkfour mb-0" v-else-if="info.city">{{info.city}}/{{info.state}}</h5>
                <h5 class="bold c-ndarkfour mb-0" v-else>-</h5>
            </div>
            <div class="infos">
                <caption class="c-nmidone bold mt-4">Website</caption>
                <BoxLoadingText v-if="!info.id" />
                <a v-else class="c-ndarkfour px-0 break mb-0" target="_blank" :href="`${website}`">
                    <h5 class="bold c-ndarkfour mb-0 ">{{ info.site || '-' }}</h5>
                </a>
            </div>
            <div class="infos mt-4">
                <caption class="c-nmidone bold">QTDE. De filiais</caption>
                <BoxLoadingText v-if="isAbleToRenderBuyerQuantity" />
                <h5 v-else class="bold c-ndarkfour mb-0">{{ info.buyers.length }}</h5>
            </div>
        </div>
        <div class="col-4 px-0 reduce-container">
            <h5 class="medium c-darkfour">Histórico na plataforma</h5>
            <div class="infos mt-4">
                <div class="d-flex align-items-center">
                    <div class="icon-history mr-3">
                        <Date color="#A1A8B8" />
                    </div>
                    <div>
                        <caption class="c-nmidone">início das operações</caption>
                        <BoxLoadingText v-if="!info.createdAt" />
                        <h4 v-else class="bold c-ndarkfour mb-0">{{ info.createdAt | formatDate}}</h4>
                    </div>
                </div>
            </div>
            <div class="infos mt-4 pt-3">
                <div class="d-flex align-items-center">
                    <div class="icon-history mr-3">
                        <MoneyTax class="w-100" />
                    </div>
                    <div>
                        <caption class="c-nmidone">total em notas</caption>
                        <BoxLoadingText v-if="!info.totalValue" />
                        <h4 v-else class="bold c-ndarkfour mb-0">R$ {{ info.totalValue | formatMoney }}</h4>
                    </div>
                </div>
            </div>
            <div class="infos mt-4 pt-3">
                <div class="d-flex align-items-center">
                    <div class="icon-history mr-3">
                        <AmountNF class="w-100" />
                    </div>
                    <div>
                        <caption class="c-nmidone bold">qtde. notas fiscais</caption>
                        <BoxLoadingText v-if="!info.totalOrders" />
                        <h4 v-else class="bold c-ndarkfour mb-0">{{ info.totalOrders }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4 px-0 increase-container">
            <h5 class="medium c-darkfour">Detalhes das operações</h5>
            <div class="infos mt-4">
                <BoxLoadingText v-if="!info.economicGroupRule" />
                <div v-else class="d-flex align-items-center">
                    <div class="icon-history mr-3">
                        <Pack
                            class="w-100"
                            size="40"
                            :bgColor="info.economicGroupRule.confirmMerchandise ? '#EDF9F7' : '#FFF7E6'"
                            :color="info.economicGroupRule.confirmMerchandise ? '#33BDA3' : '#E19700'"
                        />
                    </div>
                    <div>
                        <caption class="c-nmidone bold">Mercadoria</caption>
                        <h4 :class="info.economicGroupRule.confirmMerchandise ? 'c-greenfour' : 'c-sorangefive'" class="bold mb-0">{{ info.economicGroupRule.confirmMerchandise ? 'Confirma a entrega' : 'Não confirma a entrega' }}</h4>
                    </div>
                </div>
            </div>
            <div v-if="info.id" class="infos mt-4 pt-3">
                <div v-if="isAbleToRenderCashback" class="d-flex align-items-center">
                    <div class="icon-history mr-3">
                        <MoneyCircle class="w-100" />
                    </div>
                    <div>
                        <div class="d-flex">
                            <caption class="c-nmidone bold pr-2">Cashback</caption>
                            <el-tooltip placement="bottom">
                                <template slot="content">
                                    Este sacado exige cashback de {{ info.economicGroupRule.cashbackOperation*100 }}% a.m. <br/>
                                    sobre o valor da duplicata. Esse desconto <br/>
                                    deve ser aplicado no momento da cobrança.<br/>
                                </template>
                                <Interrogation />
                            </el-tooltip>
                        </div>
                        <BoxLoadingText v-if="isAbleToRenderCashbackOperation" />
                        <h4 v-else class="bold c-ndarkfour mb-0">{{ info.economicGroupRule.cashbackOperation*100 }}% a.m.</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <BuyerMore v-if="historyInfo" :info="info.aboutPhoto" :dialogVisible="dialogVisible" @closeModal="dialogVisible=false" />
</div>
</template>

<script>
// Icons 
import MoneyTax from '@/components/icons/MoneyTax.vue'
import NameInitials from '@/components/icons/NameInitials.vue'
import AmountNF from '@/components/icons/AmountNF.vue'
import Date from '@/components/icons/Date.vue'
import Pack from '@/components/icons/Pack.vue'
import MoneyCircle from '@/components/icons/MoneyCircleCashback.vue'
import Interrogation from '@/components/icons/Interrogation.vue'

// Modals
import BuyerMore from '@/components/modals/BuyerMore.vue'

// componentes
import BoxLoadingText from '@/components/loading/BoxLoadingText.vue'

export default {
    props: {
        info: {
            required: true,
        },
    },
    components: {
        MoneyTax,
        NameInitials,
        AmountNF,
        Date,
        BuyerMore,
        Pack,
        BoxLoadingText,
        MoneyCircle,
        Interrogation
    },
    data() {
        return {
            dialogVisible: false,
            urlApi: process.env.VUE_APP_ROOT_API,
        }
    },
    computed: {
        website() {
            if (this.info) {
                const websiteAddress = this.info.site
                if(websiteAddress){
                    if (websiteAddress.includes('http')) return websiteAddress
                    else return `http://${websiteAddress}`
                }
            }
            return  null
        },
        isAbleToRenderCashback(){
            return this.info?.economicGroupRule?.whoPaysCashback == 'sponsor'
        },
        isAbleToRenderCashbackOperation(){
            return !this.info?.economicGroupRule?.cashbackOperation
        },
        isAbleToRenderBuyerQuantity(){
            return !this.info?.buyers?.length
        }
    },
}
</script>

<style lang="scss" scoped>
.logo {
    max-width: 140px;
    border-radius: 6px;
    padding: 13px 20px;
    border: 1px solid #DFE2EB;
}

.buyer-img {
    height: 56px;
    aspect-ratio: 3/2;
    object-fit: contain;
}

hr {
    height: 1px !important;
    border: unset;
    background-color: #DFE2EB;
}
@media screen and (max-width: 1367px) {
    .reduce-container {
        max-width: 30%!important;
    }

    .increase-container {
        min-width: 40%!important;
    }
}

</style>
